import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { Icosprogress } from './progress'


@NgModule({
  declarations: [Icosprogress],
  exports: [Icosprogress],
  imports: [CommonModule],
  entryComponents: [Icosprogress],
})
export class IcosProgressModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosProgressModule, providers: [] }
  }
}
